import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {Router,CanActivate,ActivatedRouteSnapshot,RouterStateSnapshot} from '@angular/router';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';


import { User } from '../_models/index';
import { IbRequest } from '../ib-request';
import { IbResponse } from '../ib-response';
import { CallBackEndService } from '../call-back-end.service';

declare var getHexAscii:any;
const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};
@Injectable()
export class AuthenticationService {

  //webService: any;
  password: string;
  isLoad: boolean;
  userName: string;

  constructor(private router:Router,private webService: CallBackEndService) {

  }

  // login(username: string, password: string) {
 //       return this.http.post<any>('http://10.102.9.121:8080/Angular2Login/login', { username: username, password: password })
 //           .map(user => {
 //               // login successful if there's a jwt token in the response
 //               if (user && user.token) {
 //                   // store user details and jwt token in local storage to keep user logged in between page refreshes
 //                  sessionStorage.setItem('currentUser', JSON.stringify(user));
  //              }
//
 //               return user;
 //           });
 //   }
login(username: string, password: string)
  {
 
    if (this.userName !== '' || this.password !== '') {
      const request: IbRequest = new IbRequest();
      let response: IbResponse = null;
      this.isLoad = true;
      request.param1 = getHexAscii('', this.userName + this.password);
      request.param2 = this.userName;
      request.param3 = getHexAscii('', this.password);
      this.webService.getResponse(request, 'login').subscribe((data: IbResponse) => {
        response = data;
        if (response !== null && response.status === 'S200')  {
         sessionStorage.setItem('isPasswordExpire', response.param1);
         sessionStorage.setItem('token', response.param2);
         sessionStorage.setItem('custNo', response.param3);
         sessionStorage.setItem('accounts', response.param5);
          const accounts = response.param5;
          const scoAccounts = [];
          const tdAccounts = [];
          const loanAccounts = [];
          const scoAndLoanAccounts = [];
          for (const [key, value] of Object.entries(accounts)) {
            if (value === '11' || value === '12' || value === '14') {
              scoAccounts.push(key);
              scoAndLoanAccounts.push(key);
            } if (value === '20')
              tdAccounts.push(key);
            if (value === '30') {
              loanAccounts.push(key);
              scoAndLoanAccounts.push(key);
            }
          }
         sessionStorage.setItem('scoAccounts', JSON.stringify(scoAccounts));
         sessionStorage.setItem('scoAndLoanAccounts', JSON.stringify(scoAndLoanAccounts));
         sessionStorage.setItem('tdAccounts', JSON.stringify(tdAccounts));
         sessionStorage.setItem('loanAccounts', JSON.stringify(loanAccounts));
         sessionStorage.setItem('linkedAccounts', response.param6);
         sessionStorage.setItem('transactions', response.param8);
         sessionStorage.setItem('tdDetails', response.param9);
         sessionStorage.setItem('storedUserName', this.userName);
        
          this.isLoad = false;
        } else if (response.status === 'S101') {
          alert('Malicious Request Detected');
          this.isLoad = false;
        } else {
          this.isLoad = false;
        }
      });
    }

  }
    /*logout() {
      
       const request: IbRequest = new IbRequest();
      let response: IbResponse = null;
      this.isLoad = true;
      request.param1 =sessionStorage.getItem('token');
      request.param2 =sessionStorage.getItem('storedUserName');
      console.log(";;;"+request.param1+"gdfg"+request.param2);
      this.webService.getResponse(request, 'logout').subscribe((data: IbResponse) => {
        response = data;
        console.log(";;;"+data);
        if (response !== null && response.status === 'S200'){
           console.log('logout service');
       sessionStorage.removeItem('currentUser');
      this.router.navigate(['/login']);
    return false;
        } else {
          this.isLoad = false;
        }
      });
         
    }*/
 
logout(){
      //this.scAccount=this.scAccounts[0];
    console.log("call service 345345");
      const request: IbRequest = new IbRequest();
    let response: IbResponse = null;
    request.param1 =sessionStorage.getItem('token'); 
    request.param2 =sessionStorage.getItem('storedUserName');
    this.webService.getResponse(request, 'logout').subscribe((data: IbResponse) => {
      console.log('logout yuiyu'+data.status);
      
      if (data !== null && data.status === 'S200') {
        console.log('logout service');
       sessionStorage.removeItem('currentUser');
       sessionStorage.removeItem('isPasswordExpire');
         sessionStorage.removeItem('token');
         sessionStorage.removeItem('custNo');
         sessionStorage.removeItem('accounts');
       sessionStorage.clear();
      this.router.navigate(['/login']);
          
        //this.showLoanAmount ='Hide';
      }
    });
  }
  
  
}



// WEBPACK FOOTER //
// D:/Sonali/JCCBViewOnlyProject/ViewOnlyJCCBfrontend19112022/InternetBanking6.3frontend/src/app/service/authentication.service.ts